
import Vue from 'vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default Vue.extend({
  name: 'BgImgBtnBlock',
  mixins: [staticBlockMixin],
  props: {
    imageLimit: {
      type: Boolean,
      required: false,
      default: false
    }
  }
})
